import { Config } from '../config';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpClient } from '@angular/common/http';
import { ProductModel } from '../models/wardrobe.model';

@Injectable({
  providedIn: 'root'
})
export class FavoriteService extends HttpService {

  constructor(
    http: HttpClient,
  ) {
    super(http);
  }

  toggleFavorite(productId: number) {
    return this.http.post<{ favorited: boolean }>(`${Config.apiUrl}/favorites/toggle`, {
      product_id: productId
    });
  }

  favoritesList() {
    return this.http.get<{ data: ProductModel[] }>(`${Config.apiUrl}/favorites`);
  }

}
